import { render, staticRenderFns } from "./ManageRecommendations.vue?vue&type=template&id=45bce40e&"
import script from "./ManageRecommendations.vue?vue&type=script&lang=js&"
export * from "./ManageRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports